import { registerBrazeServiceWorker as registerSW } from '../../braze'

export function registerBrazeServiceWorker() {
  return registerSW()
}
